import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import {MealKitTextInput,} from '@yoni/mealcomponents-lib';

import {TranslateModule} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {ActionButtonComponent} from '../../action-button/action-button.component';
import {GreenActionButtonComponent} from '../../green-action-button/green-action-button.component';
import {FormsModule} from '@angular/forms';
import {QdmService} from '../../../Services/qdm.service';
import {Enterprise, GestionService} from '../../../Services/gestion.service';
import {AuthService} from '../../../Services/auth.service';
import {IFrameGenerator} from '../../../Utils/IFrameGenerator';
import {ModalService} from '../../../Services/modal.service';
import {Router} from '@angular/router';
import {PaymentWallService, PaymentWay,} from '../../../Services/payment-wall.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  imports: [
    TranslateModule,
    GreenActionButtonComponent,
    MealKitTextInput,
    FormsModule
  ],
  selector: 'modal-reload-wallet',
  styleUrl: './ModalReloadWallet.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ModalReloadWallet.component.html'
})
export class ModalReloadWalletComponent
  implements OnDestroy, AfterViewInit, OnInit {
  private variables = inject<any>('variables' as any);
  private qdm = inject(QdmService);
  private gestion = inject(GestionService);
  private auth = inject(AuthService);
  private modal = inject(ModalService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private wallService = inject(PaymentWallService);
  private toastr = inject(ToastrService);

  readonly fadeInContainer = viewChild('fadeInContainer', { read: ElementRef });
  readonly container = viewChild('container', { read: ElementRef });

  private sub: Subscription = new Subscription();
  minWallet: number = 0;

  paymentsWays: PaymentWay[] = [];
  private enterprise: Enterprise | undefined = undefined;

  ngOnInit(): void {
    this.sub.add(
      this.qdm.selectedEnterprise$.subscribe((ent) => {
        this.enterprise = ent;
        this.minWallet = ent?.minWallet || 0;
        this.cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.sub.add(
      this.auth.user$.subscribe((user) => {
        if (!user) {
          this.modal.close();
          return;
        }

        const restaurant = this.qdm.selectedRestaurantSubject.value;

        if (!restaurant || !this.enterprise) {
          this.modal.close();
          return;
        }

        const payments = this.enterprise?.paymentWallet || [];

        this.paymentsWays = payments.filter((p) => p !== 'WALLET') as PaymentWay[];
        this.cdr.detectChanges();

        if (this.paymentsWays.length <= 0) {
          this.modal.close();
          this.toastr.error(
            'Aucun moyen de paiement disponible pour le moment.<br /><br /><b>Veuillez ré-essayer plus tard !</b>',
            'Rechargement impossible'
          );
        }

        if (this.paymentsWays.length === 1) {
          this.togglePaymentWay(this.paymentsWays[0]);
        }

        const elem = document.querySelector(
          '#reload-wallet-input input'
        ) as HTMLInputElement;
        if (elem) {
          elem.focus();
        }

        this.cdr.detectChanges();
      })
    );
  }

  close($event: MouseEvent) {
    if ($event.target === $event.currentTarget) {
      this.modal.close();
    }
  }

  removeFadeInFromContainer() {
    const fadeInContainer = this.fadeInContainer();
    if (!fadeInContainer) {
      return;
    }

    fadeInContainer.nativeElement.classList.remove('fadeIn');
  }

  reloadWallet() {
    const reloadAmount: number = (window as any)._reloadAmount;

    const inst: ActionButtonComponent =
      this as unknown as ActionButtonComponent;
    inst._state.set('loading');
    inst._displayedLabel.set('Récupération des données...');
    const data = inst.data() as ModalReloadWalletComponent;

    data.sub.add(
      data.auth.user$.subscribe((user) => {
        if (!user) {
          inst._state.set('failed');
          inst._displayedLabel.set('Vous devez être connecté !');

          setTimeout(() => inst.reset(), 2000);
          return;
        }

        if (reloadAmount === undefined) {
          inst._state.set('failed');
          inst._displayedLabel.set('Vous devez entrer un montant !');

          setTimeout(() => inst.reset(), 2000);
          return;
        }

        if (data.minWallet !== 0 && reloadAmount < data.minWallet) {
          inst._state.set('failed');
          inst._displayedLabel.set('Le montant minimum est de ' + data.minWallet + '€');

          setTimeout(() => inst.reset(), 2000);
          return;
        }

        this.gestion
          .fetchUserEnterpriseData(user.id)
          .then((enterpriseData) => {
            const entDataId = enterpriseData?.id || -1;
            const entId = data.enterprise?.id || -1;

            if (entDataId === -1 || entId === -1) {
              inst._state.set('failed');
              inst._displayedLabel.set('Une erreur est survenue ! ' + entDataId + ':' + entId);

              setTimeout(() => inst.reset(), 2000);

              return;
            }

            if (data.selectedPaymentWay === undefined) {
              inst._state.set('failed');
              inst._displayedLabel.set('Sélectionnez un moyen de paiement !');

              setTimeout(() => inst.reset(), 2000);

              return;
            }
            inst._displayedLabel.set('Génération du lien...');

            this.gestion
              .reloadWallet(
                reloadAmount,
                entDataId,
                entId,
                data.selectedPaymentWay
              )
              .then((url) => {
                if (url === '') {
                  data.router.navigate(['/order', 'success']);
                  data.modal.close();
                  return;
                }
                inst._state.set('success');
                inst._displayedLabel.set('Affichage du paiement...');

                if (data.selectedPaymentWay === 'EDENRED') {
                  setTimeout(() => {
                    window.location.href = url;
                  }, 1000);
                } else {
                  IFrameGenerator.createAndAppendIframe(url);
                }
              })
              .catch(() => {
                inst._state.set('failed');
                inst._displayedLabel.set('Une erreur est survenue !');

                setTimeout(() => inst.reset(), 2000);
              });
          })
          .catch(() => {
            inst._state.set('failed');
            inst._displayedLabel.set('Une erreur est survenue !');

            setTimeout(() => inst.reset(), 2000);
          });
      })
    );
  }

  lastValue = '';

  updateText($event: KeyboardEvent) {
    const target = $event.target as HTMLInputElement;

    const value = target.value;

    const asNumber = Number(value);
    if (isNaN(asNumber) || value.includes('.') || value.includes(',')) {
      target.value = this.lastValue;
      return;
    }

    this.lastValue = value;

    (window as any)._reloadAmount = asNumber;
  }

  readonly payBtn = viewChild<GreenActionButtonComponent>('payBtn');

  clickOnPay() {
    const payBtn = this.payBtn();
    if (payBtn) {
      payBtn.call();
    }
  }

  computeIconHtml(payment: PaymentWay): string {
    switch (payment) {
      case 'CB':
        return "<img src='/assets/images/logo/paygreen.webp' class='h-12' alt='Logo Multi-Paiement' />";
      case 'WALLET':
        return `<div class="pl-2 h-12 flex items-center"><span class="material-icons">wallet</span></div>`;
      case 'EDENRED':
        return "<img src='/assets/images/logo/edenred_logo.webp' class='h-12' alt='Logo Multi-Paiement' />";
    }
  }

  selectedPaymentWay: PaymentWay | undefined = undefined;

  togglePaymentWay(payment: PaymentWay) {
    if (this.selectedPaymentWay === payment) {
      this.selectedPaymentWay = undefined;
    } else {
      this.selectedPaymentWay = payment;
    }
  }

  isPaymentSelected(way: PaymentWay) {
    return this.selectedPaymentWay === way;
  }

  formatWay(way: PaymentWay): string {
    switch (way) {
      case 'CB':
        return 'Carte bancaire';
      case 'WALLET':
        return `Portefeuille`;
      case 'EDENRED':
        return 'Ticket Restaurant';
    }
  }
}
